module.exports = __webpack_public_path__ + "static/media/onboarding4.17d499f2.svg";